import { AxiosError } from 'axios';

/**
 * Extracts a user-friendly error message from an Axios error response.
 * - 429: returns a "too many requests" message
 * - 403: surfaces the API body if it's a user-facing message, otherwise a permission fallback
 * - 400: returns the API body string if present, otherwise a fallback
 * - everything else: returns the provided fallback
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
    const axiosError = error as AxiosError;
    const status = axiosError?.response?.status;

    if (status === 429) {
        return "You're doing that too fast. Please wait a moment and try again.";
    }

    if (status === 403) {
        const data = axiosError.response?.data;
        if (typeof data === 'string' && data.trim()) {
            return data.trim();
        }
        return "You don't have permission to do that.";
    }

    if (status === 400) {
        const data = axiosError.response?.data;
        if (typeof data === 'string' && data.trim()) {
            return data.trim();
        }
    }

    return fallback;
}
